import heroSlider from './components/hero-slider'
import threeSixtyGallery from './components/three-sixty-gallery'
import navigation from './components/navigation'
import joinTheList from './components/join-the-list'
import videoModule from './components/lightbox'
import twoColumnsSlider from './components/two-columns-slider';
import neighborhood from './components/neighborhood';
import mapLocations from './components/map-locations';
import updatesGrid from './components/updates-grid'
import updates from './components/updates'
import scrollmagic from './components/scrollmagic';
import floorplan from './components/floorplans';
import sliderWithText from './components/slider-with-text';

function main() {
    heroSlider()
    threeSixtyGallery()
    navigation()
    videoModule()
    twoColumnsSlider()
    neighborhood()
    mapLocations()
    updatesGrid()
    scrollmagic()
    joinTheList()
    updates()
    floorplan()
    sliderWithText()
}

$(document).ready(main)
